export const DIGITAL_SIGN_SOCKET_BASEURL = () => {

    return 'https://digisignsocket.bossstudio.tv';
    const instanceRes = JSON.parse(localStorage.getItem('instance'));

    if (!instanceRes || !instanceRes.DigitalSignSocketBaseUrl) {
        console.error("DigitalSignSocketBaseUrl not found in local storage");
        return null;
    }

    return instanceRes.DigitalSignSocketBaseUrl;
};
